import { humanize } from '@/lib/format'
import { StatusPill } from './StatusPill'
import type { StatusFamily } from '@/types'

/** Gateway transaction/payout status → brand status family pill. */
export function TransactionStatusBadge({ status, family }: { status: string; family: StatusFamily }) {
  return <StatusPill family={family}>{humanize(status)}</StatusPill>
}
